import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {
    imagePicker_template
} from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {imagePickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import {imageWidget_template} from "./imageWidget_template";

declare var ko: any;

export class config_login_template extends vnTemplate {


    protected loginSystemEmailTemplatesFilter: filterDropdown_template;
    protected personalThreadNotificationEmailTemplatesFilter: filterDropdown_template;
    protected followUpdateNotificationEmailTemplatesFilter: filterDropdown_template;
    protected hasActionBarFilter: filterDropdown_template;
    protected hasThreadSuggestionsFilter: filterDropdown_template;
    protected styleFilter: filterDropdown_template;
    public imagePicker: imagePicker_template;
    public imagePickerHelper: imagePickerHelper;
    public imageWidgetForNewsletterBackgroundImage: imageWidget_template;

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected getTemplateHtml(): string {
        return /*html*/ `
        <div class="w-form w-form-large">

            <div class="form-header">
                <h3 class="form-title icon i-login">Login Config</h3>
            </div>

            <div class="w-form-body">

                <div class="form-body">
                    <strong class="form-sub-title parent">ARTICLE LIMIT</strong>
                    <div class="form-group" >
                        <input id="skipBannerEnable" type="checkbox" data-bind="checked: skipBannerEnable">
                        <label for="skipBannerEnable" class="form-label icon i-check">Allow Bypass of Article Limit</label>
                    </div>

                    <div class="form-group">
                        <label for="styleFilter" class="form-label">Style</label>
                        ${this.styleFilter.getHtmlBuild()}
                    </div>

                    <!-- ko if: showPopupStyleTriggers -->
                    <div class="form-group">
                        <label for="percentageScrollDepthTrigger" class="form-label">Percentage Scroll Depth Trigger</label>
                        <input class="input-text" type="number" min="0" max="100" data-bind="value: percentageScrollDepthTrigger" id="percentageScrollDepthTrigger">
                    </div>
                    <div class="form-group">
                        <label for="secondsOnPageTrigger" class="form-label">Seconds on Page Trigger</label>
                        <input class="input-text" type="number" min="0" data-bind="value: secondsOnPageTrigger" id="secondsOnPageTrigger">
                    </div>
                    <!-- /ko -->
                    <div class="form-group">
                        <label for="cooldownTime" class="form-label">Cooldown Time (seconds)</label>
                        <input class="input-text" type="number"  data-bind="value: cooldownTime" id="cooldownTime">
                    </div>
                    <div class="form-group">
                        <label for="cooldownArticleCount" class="form-label">Cooldown Article Count</label>
                        <input class="input-text" type="number" min="0" data-bind="value: cooldownArticleCount" id="cooldownArticleCount">
                    </div>
                    <strong class="form-sub-title content">PAGE DEPTH</strong>
                    <div class="form-group">
                        <label for="maxUnauthenicatedArticleViews" class="form-label">PAGE DEPTH ARTICLE TARGET</label>
                        <input class="input-text" type="number" data-bind="value: maxUnauthenicatedArticleViews" id="maxUnauthenicatedArticleViews" >                        
                    </div>

                    <strong class="form-sub-title content">Weekly Rate</strong>
                    <div class="form-group">
                        <label for="lowRangeMinimumRate" class="form-label">LOW RANGE MINIMUM RATE</label>
                        <input class="input-text" type="number" data-bind="value: lowRangeMinimumRate" id="lowRangeMinimumRate">
                    </div>
                    <div class="form-group">
                        <label for="lowRangeArticleTarget" class="form-label">LOW RANGE ARTICLE TARGET</label>
                        <input class="input-text" type="number" data-bind="value: lowRangeArticleTarget" id="lowRangeArticleTarget" >
                    </div>
                    <div class="form-group">
                        <label for="midRangeMinimumRate" class="form-label">MID RANGE MINIMUM RATE</label>
                        <input class="input-text" type="number" data-bind="value: midRangeMinimumRate" id="midRangeMinimumRate" >
                    </div>
                    <div class="form-group">
                        <label for="midRangeArticleTarget" class="form-label">MID RANGE ARTICLE TARGET</label>
                        <input class="input-text" type="number" data-bind="value: midRangeArticleTarget" id="midRangeArticleTarget" >
                    </div>
                    <div class="form-group">
                        <label for="highRangeMinimumRate" class="form-label">HIGH RANGE MINIMUM RATE</label>
                        <input class="input-text" type="number" data-bind="value: highRangeMinimumRate" id="highRangeMinimumRate" >
                    </div>
                    <div class="form-group">
                        <label for="highRangeArticleTarget" class="form-label">HIGH RANGE ARTICLE TARGET</label>
                        <input class="input-text" type="number" data-bind="value: highRangeArticleTarget" id="highRangeArticleTarget" >
                    </div>

                    <strong class="form-sub-title parent">Login Methods</strong>

                    <div class="form-group">
                        <label for="amazonClientId" class="form-label">Amazon Client Id</label>
                        <input class="input-text" type="text" data-bind="value: amazonClientId" id="amazonClientId" >
                    </div>
                    <div class="form-group">
                        <label for="appleClientId" class="form-label">Apple Client Id</label>
                        <input class="input-text" type="text" data-bind="value: appleClientId " id="appleClientId" >
                    </div>

                       <div class="form-group">
                        <label for="discordClientId" class="form-label">Discord Client Id</label>
                        <input class="input-text" type="text" data-bind="value: discordClientId " id="discordClientId" >
                    </div>
                    <div class="form-group">
                        <label for="discordClientSecret" class="form-label">Discord Client Secret</label>
                        <input class="input-text" type="text" data-bind="value: discordClientSecret" id="discordClientSecret" >
                    </div>

                    <div class="form-group">
                        <label for="FacebookClientId" class="form-label">Facebook Client Id</label>
                        <input class="input-text" type="text" data-bind="value: facebookClientId" id="facebookClientId" >
                    </div>
                    <div class="form-group">
                        <label for="FacebookClientSecret" class="form-label">Facebook Client Secret</label>
                        <input class="input-text" type="text" data-bind="value: facebookClientSecret" id="FacebookClientSecret" >
                    </div>
                    <div class="form-group">
                        <label for="googleClientId" class="form-label">Google Client Id</label>
                        <input class="input-text" type="text" data-bind="value: googleClientId" id="googleClientId" >
                    </div>
                    <div class="form-group">
                        <label for="openPassClientId" class="form-label">OpenPass Client Id</label>
                        <input class="input-text" type="text" data-bind="value: openPassClientId" id="openPassClientId" >
                    </div>

                    <div class="form-group">
                        <label for="steamClientId" class="form-label">Steam Client Id</label>
                        <input class="input-text" type="text" data-bind="value: steamClientId" id="steamClientId" >
                    </div>
                    
                    <div class="form-group">
                        <label for="twitchClientId" class="form-label">Twitch Client Id</label>
                        <input class="input-text" type="text" data-bind="value: twitchClientId" id="twitchClientId" >
                    </div>
                    <div class="form-group">
                        <label for="twitchClientSecret" class="form-label">Twitch Client Secret</label>
                        <input class="input-text" type="text" data-bind="value: twitchClientSecret" id="twitchClientSecret" >
                    </div>

                     <div id="sortable_list" class="form-body-scroll mailing-list">
                        <strong class="form-sub-title content">Order Of Login Methods</strong>
                        <div class="" data-bind="visible: sortables().length == 0">
                            <span style="margin:2rem auto; display: block;background: #fffae6;padding: 1rem;max-width: 400px;border: 1px dashed #e4d8ab;"> There are no mailing list available</span>
                        </div>

                        <table id="spec_section_list" class="list-action full-width" data-bind="visible: sortables().length >= 1">
                            <thead>
                                <tr style="background-color:#f2f2f2">
                                    <th class="short"></th>
                                    <th style="text-align: left"><span>Name</span></th>

                                </tr>
                            </thead>
                            <tbody data-bind="foreach: sortables, childrenComplete : handleDragAndDrop($element, sortables ,'.form-row')" >
                                <tr class="form-row" data-bind="css:{ 'is-active' : isActive}">
                                    <td class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></td>
                                    <td style="text-align: left"><span data-bind="text: name"></td>

                                </tr>
                            </tbody>
                        </table>


                    </div>
                </div>

                <div class="form-body">

                    <strong class="form-sub-title parent">PREMIUM</strong>
                    <div class="form-group">
                        <label for="premiumOfferUrlForAdRemoval" class="form-label">Premium Remove Ads Permalink</label>
                        <input id="premiumOfferUrlForAdRemoval" class="input-text" type="text" data-bind="value: premiumOfferUrlForAdRemoval" style="flex:8;">
                    </div>

                    <strong class="form-sub-title parent">EMAIL</strong>
                    <div class="form-group">
                        <label for="newsletterHeadline" class="form-label">Newsletter Headline</label>
                        <textarea class="input-text" type="text" data-bind="value: newsletterHeadline" id="newsletterHeadline" style="flex:8;"></textarea>
                    </div>
                    <div class="form-group">
                        <label for="newsletterDescription" class="form-label">Newsletter Description</label>
                        <textarea class="input-text" type="text" data-bind="value: newsletterDescription" id="newsletterDescription" style="flex:8;"></textarea>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Newsletter Background Image</label>
                        <div class="image-picker-container" style="flex: 8;">
                            ${this.imageWidgetForNewsletterBackgroundImage.getHtmlBuild()}
                        </div>
                    </div>
                    <div class="form-group flex">
                        <label class="form-label">Newsletter Background Color</label>
                        <input type="color"
                               class="input-color"
                               data-bind="value: newsletterBackgroundColorPicker, event: { change: onNewsletterBackgroundColorChange, input: onNewsletterBackgroundColorChange }">
                        <span class="form-label" style="flex: none; margin-left: 10px;" data-bind="visible: !newsletterBackgroundColor()">Not set</span>
                        <button type="button"
                                class="btn small w-auto"
                                data-bind="click: clearNewsletterBackgroundColor, visible: newsletterBackgroundColor()">Clear Color</button>
                    </div>

                    <div class="form-group">
                        <label for="logoUrl" class="form-label short">Login System Email Template</label>
                        ${ this.loginSystemEmailTemplatesFilter.getHtmlBuild() }
                    </div>
                    <div class="form-group">
                        <label for="logoUrl" class="form-label short">Thread Interaction Notifications Email Template</label>
                        ${ this.personalThreadNotificationEmailTemplatesFilter.getHtmlBuild() }
                    </div>
                    <div class="form-group">
                        <label for="logoUrl" class="form-label short">Follow Update Notifications Email Template</label>
                        ${ this.followUpdateNotificationEmailTemplatesFilter.getHtmlBuild() }
                    </div>

                    <strong class="form-sub-title parent">GENERAL</strong>
                    <div class="form-group">
                        <label for="hasActionBar" class="form-label">Has Action Bar</label>
                        ${this.hasActionBarFilter.getHtmlBuild()}
                    </div>
                    <div class="form-group">
                        <label for="hasThreadSuggestions" class="form-label">Has Thread Submissions</label>
                        ${this.hasThreadSuggestionsFilter.getHtmlBuild()}
                    </div>
                    <strong class="form-sub-title parent">First Party Data</strong>
                    <div class="form-group">
                        <input id="collectionForm" type="checkbox" data-bind="checked: collectionForm">
                        <label for="collectionForm" class="form-label icon i-check">Collection Form</label>
                    </div>
                </div>
            </div>

            <div class="form-footer">
                <button data-bind="event: {click: onClickCancelLoginSettings}" class="btn " type="button">Cancel</button>
                <button data-bind="event: {click: onClickSaveLoginSettings}" class="btn highlight" type="button">Save</button>
            </div>
            ${this.imagePicker.getHtmlBuild()}
        </div>
         `;
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            maxUnauthenicatedArticleViews: ko.observable(""),
            lowRangeMinimumRate: ko.observable(""),
            lowRangeArticleTarget : ko.observable(""),
            midRangeMinimumRate : ko.observable(""),
            midRangeArticleTarget : ko.observable(""),
            highRangeMinimumRate : ko.observable(""),
            highRangeArticleTarget : ko.observable(""),
            numberCharactersMobileArticleLimit: ko.observable(""),
            numberCharactersDesktopArticleLimit: ko.observable(""),
            skipBannerEnable: ko.observable(false),
            skipBannerEnableTopButton: ko.observable(false),
            premiumOfferUrlForAdRemoval: ko.observable(''),
            newsletterHeadline: ko.observable(""),
            newsletterDescription: ko.observable(""),
            newsletterBackgroundColor: ko.observable(""),
            newsletterBackgroundColorPicker: ko.observable("#ffffff"),
            googleClientId: ko.observable(""),
            amazonClientId: ko.observable(""),
            openPassClientId: ko.observable(""),
            facebookClientId: ko.observable(""),
            facebookClientSecret: ko.observable(""),
            discordClientId: ko.observable(""),
            discordClientSecret: ko.observable(""),
            appleClientId: ko.observable(""),
            steamClientId: ko.observable(""),
            twitchClientId: ko.observable(""),
            twitchClientSecret: ko.observable(""),
            cooldownTime: ko.observable(""),
            cooldownArticleCount: ko.observable(""),
            percentageScrollDepthTrigger: ko.observable(""),
            secondsOnPageTrigger: ko.observable(""),
            collectionForm: ko.observable(false),
            sortables: ko.observableArray([
                {
                    name: "Google",
                    isActive: true,
                },  {
                    name: "facebook",
                    isActive: true,

                },  {
                    name: "Apple",
                    isActive: true,

                }
            ]),
            handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                self.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            },

            onClickCancelLoginSettings: function (data, event) {
                self.onClickCancelLoginSettings();
            },
            onClickSaveLoginSettings: function (data, param, event) {
                self.onClickSaveLoginSettings();
            },
            clearNewsletterBackgroundColor: function () {
                self.clearNewsletterBackgroundColor();
            },
            onNewsletterBackgroundColorChange: function () {
                self.onNewsletterBackgroundColorChange();
            }
        }
    }

    protected initPartial(): void {

        this.loginSystemEmailTemplatesFilter = new filterDropdown_template('loginSystemEmailTemplatesFilter', this.getTemplateViewModel(), this.caller);
        this.loginSystemEmailTemplatesFilter.setLabel('Template');
        this.personalThreadNotificationEmailTemplatesFilter = new filterDropdown_template('personalThreadNotificationEmailTemplatesFilter', this.getTemplateViewModel(), this.caller);
        this.personalThreadNotificationEmailTemplatesFilter.setLabel('Template');
        this.followUpdateNotificationEmailTemplatesFilter = new filterDropdown_template('followUpdateNotificationEmailTemplatesFilter', this.getTemplateViewModel(), this.caller);
        this.followUpdateNotificationEmailTemplatesFilter.setLabel('Template');
        this.hasActionBarFilter = new filterDropdown_template('hasActionBarFilter', this.getTemplateViewModel(), this.caller);
        this.hasActionBarFilter.setOptions([{id: 'none', name: 'None'},{id: 'logged-in-users', name: 'Logged-In Users'},{id: 'all', name: 'All Users'}]);
        this.hasActionBarFilter.setLabel('Has Action Bar');
        this.hasThreadSuggestionsFilter = new filterDropdown_template('hasThreadSuggestionsFilter', this.getTemplateViewModel(), this.caller);
        this.hasThreadSuggestionsFilter.setOptions([
            {id: 0, name: 'None'},
            {id: 1, name: 'All'}
        ]);
        this.hasThreadSuggestionsFilter.setLabel('Has Thread Suggestions');


        this.styleFilter = new filterDropdown_template('styleFilter', this.getTemplateViewModel(), this.caller);
        this.styleFilter.setOptions([{id: 'popup', name: 'Popup'},{id: 'in-content', name: 'In-Content'},{id: 'popup-minimal', name: 'Popup Minimal'}]);
        this.styleFilter.setLabel('Style');

        var vm = this.getTemplateViewModel();
        var self = this;
        vm.showPopupStyleTriggers = ko.computed(function () {
            var style = self.styleFilter.getTemplateViewModel().selectedOption();
            return style === 'popup' || style === 'popup-minimal';
        });

        this.imagePicker = new imagePicker_template('imagePicker', this.getTemplateViewModel(), this.caller);

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.getTemplateViewModel(),
            this.caller.getVnAppZone(),
            this.caller
        );

        this.imageWidgetForNewsletterBackgroundImage = new imageWidget_template(
            "newsletterBackgroundImage",
            this.getTemplateViewModel(),
            this
        );
        this.imageWidgetForNewsletterBackgroundImage.setMode("single-select");
        this.imageWidgetForNewsletterBackgroundImage.setCaller(this.imagePickerHelper);
    }


    protected getTemplateName(): string {
        return "config_login_template";
    }

    public getLoginSettings() {

        return {
            maxUnauthenicatedArticleViews: this.getTemplateViewModel().maxUnauthenicatedArticleViews(),
            lowRangeMinimumRate: this.getTemplateViewModel().lowRangeMinimumRate(),
            lowRangeArticleTarget: this.getTemplateViewModel().lowRangeArticleTarget(),
            midRangeMinimumRate: this.getTemplateViewModel().midRangeMinimumRate(),
            midRangeArticleTarget: this.getTemplateViewModel().midRangeArticleTarget(),
            highRangeMinimumRate: this.getTemplateViewModel().highRangeMinimumRate(),
            highRangeArticleTarget: this.getTemplateViewModel().highRangeArticleTarget(),
            skipBannerEnable: this.getTemplateViewModel().skipBannerEnable(),
            skipBannerEnableTopButton: this.getTemplateViewModel().skipBannerEnableTopButton(),
            premiumOfferUrlForAdRemoval: this.getPremiumOfferUrlForAdRemoval(),
            newsletterHeadline: this.getTemplateViewModel().newsletterHeadline(),
            newsletterDescription: this.getTemplateViewModel().newsletterDescription(),
            newsletterBackgroundImage: this.imageWidgetForNewsletterBackgroundImage.getImage(),
            newsletterBackgroundColor: this.getTemplateViewModel().newsletterBackgroundColor(),
            loginSystemEmailTemplateId: this.loginSystemEmailTemplatesFilter.getTemplateViewModel().selectedOption() ? this.loginSystemEmailTemplatesFilter.getTemplateViewModel().selectedOption() : null,
            personalThreadNotificationEmailTemplateId: this.personalThreadNotificationEmailTemplatesFilter.getTemplateViewModel().selectedOption() ? this.personalThreadNotificationEmailTemplatesFilter.getTemplateViewModel().selectedOption() : null,
            followUpdateNotificationEmailTemplateId: this.followUpdateNotificationEmailTemplatesFilter.getTemplateViewModel().selectedOption() ? this.followUpdateNotificationEmailTemplatesFilter.getTemplateViewModel().selectedOption() : null,
            hasActionBar: this.hasActionBarFilter.getTemplateViewModel().selectedOption() ? this.hasActionBarFilter.getTemplateViewModel().selectedOption() : null,
            hasThreadSuggestions: this.hasThreadSuggestionsFilter.getTemplateViewModel().selectedOption() ? this.hasThreadSuggestionsFilter.getTemplateViewModel().selectedOption() : null,
            articleLimitStyle: this.styleFilter.getTemplateViewModel().selectedOption() ? this.styleFilter.getTemplateViewModel().selectedOption() : null,
            googleClientId: this.getTemplateViewModel().googleClientId(),
            amazonClientId: this.getTemplateViewModel().amazonClientId(),
            openPassClientId: this.getTemplateViewModel().openPassClientId(),
            facebookClientId: this.getTemplateViewModel().facebookClientId(),
            facebookClientSecret: this.getTemplateViewModel().facebookClientSecret(),
            discordClientId: this.getTemplateViewModel().discordClientId(),
            discordClientSecret: this.getTemplateViewModel().discordClientSecret(),
            appleClientId: this.getTemplateViewModel().appleClientId(),
            steamClientId: this.getTemplateViewModel().steamClientId(),
            twitchClientId: this.getTemplateViewModel().twitchClientId(),
            twitchClientSecret: this.getTemplateViewModel().twitchClientSecret(),
            loginPlatformOrder: this.getTemplateViewModel().sortables(),
            cooldownTime: this.getTemplateViewModel().cooldownTime(),
            cooldownArticleCount: this.getTemplateViewModel().cooldownArticleCount(),
            percentageScrollDepthTrigger: this.getTemplateViewModel().percentageScrollDepthTrigger(),
            secondsOnPageTrigger: this.getTemplateViewModel().secondsOnPageTrigger(),
            collectionForm: this.getTemplateViewModel().collectionForm(),
        }
    }

    public setNewsletterHeadline(newsletterHeadline) {
        this.getTemplateViewModel().newsletterHeadline(newsletterHeadline);
    }

    public setNewsletterDescription(newsletterDescription) {
        this.getTemplateViewModel().newsletterDescription(newsletterDescription);
    }

    public setNewsletterBackgroundImage(newsletterBackgroundImage) {
        if (!newsletterBackgroundImage || !newsletterBackgroundImage.url) {
            this.imageWidgetForNewsletterBackgroundImage.clearImage();
            return;
        }
        this.imageWidgetForNewsletterBackgroundImage.setImage(newsletterBackgroundImage);
    }

    public setNewsletterBackgroundColor(newsletterBackgroundColor) {
        const normalizedHex = this.normalizeNewsletterBackgroundColor(newsletterBackgroundColor);
        this.getTemplateViewModel().newsletterBackgroundColor(normalizedHex);
        this.getTemplateViewModel().newsletterBackgroundColorPicker(normalizedHex || "#ffffff");
    }

    public clearNewsletterBackgroundColor() {
        this.getTemplateViewModel().newsletterBackgroundColor("");
        this.getTemplateViewModel().newsletterBackgroundColorPicker("#ffffff");
    }

    public onNewsletterBackgroundColorChange() {
        const pickedColor = (this.getTemplateViewModel().newsletterBackgroundColorPicker() || "").trim();
        this.getTemplateViewModel().newsletterBackgroundColor(this.normalizeNewsletterBackgroundColor(pickedColor));
    }

    private normalizeNewsletterBackgroundColor(color): string {
        if (color === null || typeof color === 'undefined') {
            return "";
        }

        const value = String(color).trim();
        if (value === "") {
            return "";
        }

        const hex = this.normalizeHexColor(value);
        if (hex) {
            return hex;
        }

        const rgbHex = this.normalizeRgbToHex(value);
        if (rgbHex) {
            return rgbHex;
        }

        return "";
    }

    private normalizeHexColor(value: string): string | null {
        const shortHexMatch = /^#([0-9a-f]{3})$/i.exec(value);
        if (shortHexMatch) {
            const hex = shortHexMatch[1];
            return ("#" + hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]).toLowerCase();
        }

        const fullHexMatch = /^#([0-9a-f]{6})$/i.exec(value);
        if (fullHexMatch) {
            return ("#" + fullHexMatch[1]).toLowerCase();
        }

        return null;
    }

    private normalizeRgbToHex(value: string): string | null {
        const rgbMatch = /^rgba?\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})(?:\s*,\s*([0-9.]+)\s*)?\)$/i.exec(value);
        if (!rgbMatch) {
            return null;
        }

        const toByte = (n: number): number => {
            if (isNaN(n)) {
                return 0;
            }
            if (n < 0) {
                return 0;
            }
            if (n > 255) {
                return 255;
            }
            return Math.round(n);
        };

        const toHex2 = (n: number): string => {
            const s = toByte(n).toString(16);
            return s.length === 1 ? "0" + s : s;
        };

        const r = parseInt(rgbMatch[1], 10);
        const g = parseInt(rgbMatch[2], 10);
        const b = parseInt(rgbMatch[3], 10);

        return ("#" + toHex2(r) + toHex2(g) + toHex2(b)).toLowerCase();
    }

    public setMaxUnauthenicatedArticleViews(maxUnauthenicatedArticleViews) {
        this.getTemplateViewModel().maxUnauthenicatedArticleViews(maxUnauthenicatedArticleViews);
    }

    public setLowRangeMinimumRate(lowRangeMinimumRate) {
        this.getTemplateViewModel().lowRangeMinimumRate(lowRangeMinimumRate);
    }

    public setLowRangeArticleTarget(lowRangeArticleTarget) {
        this.getTemplateViewModel().lowRangeArticleTarget(lowRangeArticleTarget);
    }

    public setMidRangeMinimumRate(midRangeMinimumRate) {
        this.getTemplateViewModel().midRangeMinimumRate(midRangeMinimumRate);
    }

    public setMidRangeArticleTarget(midRangeArticleTarget) {
        this.getTemplateViewModel().midRangeArticleTarget(midRangeArticleTarget);
    }

    public setHighRangeMinimumRate(highRangeMinimumRate) {
        this.getTemplateViewModel().highRangeMinimumRate(highRangeMinimumRate);
    }

    public setHighRangeArticleTarget(highRangeArticleTarget) {
        this.getTemplateViewModel().highRangeArticleTarget(highRangeArticleTarget);
    }

    public setSkipBannerEnable(skipBannerEnable) {
        this.getTemplateViewModel().skipBannerEnable(skipBannerEnable);
    }

    public setSkipBannerEnableTopButton(skipBannerEnableTopButton) {
        this.getTemplateViewModel().skipBannerEnableTopButton(skipBannerEnableTopButton);
    }

    protected onClickCancelLoginSettings(): any {
        this.caller.cancelSiteSettings()
    }

    protected onClickSaveLoginSettings(): any {


        if ((typeof this.getTemplateViewModel().facebookClientId() === 'undefined' || this.getTemplateViewModel().facebookClientId().trim() === '') &&
            (typeof this.getTemplateViewModel().facebookClientSecret() !== 'undefined' && this.getTemplateViewModel().facebookClientSecret().trim() !== '')) {
            alert('Please fill in both facebook Client ID and Client Secret, or leave them both empty.');
            return;
        }
        if ((typeof this.getTemplateViewModel().discordClientId() === 'undefined' || this.getTemplateViewModel().discordClientId().trim() === '') &&
            (typeof this.getTemplateViewModel().discordClientSecret() !== 'undefined' && this.getTemplateViewModel().discordClientSecret().trim() !== '')) {
            alert('Please fill in both Discord Client ID and Client Secret, or leave them both empty.');
            return;
        }
        this.updateListPositions();
        this.caller.saveLoginSettings();
    }

    protected setLoginSystemEmailTemplates(option) {

        this.loginSystemEmailTemplatesFilter.setOptions(option);
    }

    protected setLoginSystemEmailTemplate(id) {

        this.loginSystemEmailTemplatesFilter.setSelectedOption(id);
    }

    protected setPersonalThreadNotificationEmailTemplates(option) {

        this.personalThreadNotificationEmailTemplatesFilter.setOptions(option);
    }

    protected setPersonalThreadNotificationEmailTemplate(id) {

        this.personalThreadNotificationEmailTemplatesFilter.setSelectedOption(id);
    }

    protected setFollowUpdateNotificationEmailTemplates(option) {

        this.followUpdateNotificationEmailTemplatesFilter.setOptions(option);
    }

    protected setFollowUpdateNotificationEmailTemplate(id) {

        this.followUpdateNotificationEmailTemplatesFilter.setSelectedOption(id);
    }

    protected setPremiumOfferUrlForAdRemoval(getPremiumOfferUrlForAdRemoval) {

        this.getTemplateViewModel().premiumOfferUrlForAdRemoval(getPremiumOfferUrlForAdRemoval);
    }

    protected getPremiumOfferUrlForAdRemoval() {
        return this.getTemplateViewModel().premiumOfferUrlForAdRemoval();
    }

    protected setHasActionBar(hasActionBarId) {
        this.hasActionBarFilter.setSelectedOption(hasActionBarId);
    }

    protected setStyle(styleId) {
        this.styleFilter.setSelectedOption(styleId);
    }

    protected setHasThreadSuggestions(hasThreadSuggestionsId) {
        this.hasThreadSuggestionsFilter.setSelectedOption(hasThreadSuggestionsId);
    }

    public setGoogleClientId(googleClientId) {
        this.getTemplateViewModel().googleClientId(googleClientId);
    }

    public setAmazonClientId(amazonClientId) {
        this.getTemplateViewModel().amazonClientId(amazonClientId);
    }

    public setOpenPassClientId(openPassClientId) {
        this.getTemplateViewModel().openPassClientId(openPassClientId);
    }

    public setFacebookClientId(facebookClientId) {
        this.getTemplateViewModel().facebookClientId(facebookClientId);
    }
    public setFacebookClientSecret(facebookClientSecret) {
        this.getTemplateViewModel().facebookClientSecret(facebookClientSecret);
    }


    public setDiscordClientId(discordClientId) {
        this.getTemplateViewModel().discordClientId(discordClientId);
    }

    public setDiscordClientSecret(discordClientSecret) {
        this.getTemplateViewModel().discordClientSecret(discordClientSecret);
    }
    public setAppleClientId(appleClientId) {
        this.getTemplateViewModel().appleClientId(appleClientId);
    }

    public setSteamClientId(steamClientId) {
        this.getTemplateViewModel().steamClientId(steamClientId);
    }

    public setTwitchClientId(twitchClientId) {
        this.getTemplateViewModel().twitchClientId(twitchClientId);
    }
    public setTwitchClientSecret(twitchClientSecret) {
        this.getTemplateViewModel().twitchClientSecret(twitchClientSecret);
    }

    public setCooldownTime(cooldownTime) {
        this.getTemplateViewModel().cooldownTime(cooldownTime != null ? cooldownTime : "");
    }

    public setCooldownArticleCount(cooldownArticleCount) {
        this.getTemplateViewModel().cooldownArticleCount(cooldownArticleCount != null ? cooldownArticleCount : "");
    }

    public setPercentageScrollDepthTrigger(percentageScrollDepthTrigger) {
        this.getTemplateViewModel().percentageScrollDepthTrigger(percentageScrollDepthTrigger != null ? percentageScrollDepthTrigger : "");
    }

    public setSecondsOnPageTrigger(secondsOnPageTrigger) {
        this.getTemplateViewModel().secondsOnPageTrigger(secondsOnPageTrigger != null ? secondsOnPageTrigger : "");
    }

    public setCollectionForm(collectionForm) {
        this.getTemplateViewModel().collectionForm(collectionForm ? true : false);
    }

    protected updateListPositions(){

        let sortables = this.getTemplateViewModel().sortables();

        for (var i = 0; i < sortables.length; i++) {

            sortables[i].position = i + 1;
        }


    }

    public setSortables(sortables){

         let    sortablesDefault  = [
                {name:'apple', isActive: true,position:1},
                {name:'facebook',isActive: true,position:2},
                {name:'google', isActive: true  ,position:3},
                {name:'discord', isActive: true ,position:4},
                {name:'email', isActive: true    ,position:5},
                {name:'amazon', isActive: true  ,position:6},
                {name:'openpass', isActive: true  ,position:7},
                {name:'steam', isActive: true  ,position:7},
                {name:'twitch', isActive: true  ,position:8},
            ];
            if(!sortables || sortables.length === 0){
            sortables = sortablesDefault;
            }else{
                // Add any items from defaults that aren't in the incoming sortables (case-insensitive comparison)
                for(var i = 0; i < sortablesDefault.length; i++){
                    var found = false;
                    for(var j = 0; j < sortables.length; j++){
                        // Case-insensitive comparison
                        if(sortablesDefault[i].name.toLowerCase() === sortables[j].name.toLowerCase()){
                            found = true;
                            break;
                        }
                    }
                    if(!found){
                        sortables.push(sortablesDefault[i]);
                    }
                }
            }

        this.getTemplateViewModel().sortables(sortables);

    }
    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/config_login_template.ts